// app/javascript/controllers/toggle_controller.js
import { Controller } from "@hotwired/stimulus"

// Usage:
// <div data-controller="toggle">
//   <button data-action="click->toggle#toggle">Toggle</button>
//   <div data-toggle-target="content">This will be shown/hidden</div>
// </div>
export default class extends Controller {
  static targets = ["content"]

  toggle() {
    this.contentTargets.forEach((el) => {
      el.classList.toggle("d-none")
    })
  }
}
